import {Delete} from '@mui/icons-material';
import {Box, Typography} from '@mui/material';
import {AppIconButton} from 'components/buttons';
import {MediaFileModel} from 'models';
import React from 'react';
interface SimpleFilePreviewProps {
    files: MediaFileModel[];
    onRemove: (file: MediaFileModel) => void;
    loading?: boolean;
}
export const SimpleFilePreview: React.FC<SimpleFilePreviewProps> = ({files, onRemove, loading = false}) => {
    return (
        <Box sx={{mt: 2}}>
            {files.map(file => (
                <Box
                    key={`${file.id}`}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        p: 1,
                        mb: 1,
                        bgcolor: 'grey.50',
                        borderRadius: 1,
                        border: '1px solid',
                        borderColor: 'grey.200',
                    }}
                >
                    <Box>
                        <Typography variant="body2" sx={{fontWeight: 500}}>
                            <a
                                href={`${process.env.REACT_APP_API_BASE_URL}/${file.partialFilePath}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{textDecoration: 'none', color: 'blue'}}
                            >
                                {file.title}
                            </a>
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            {Math.round(file.sizeInKbs)} KB
                        </Typography>
                    </Box>
                    <AppIconButton isLoading={loading} size="small" onClick={() => onRemove(file)} color="error">
                        <Delete fontSize="small" />
                    </AppIconButton>
                </Box>
            ))}
        </Box>
    );
};

export default SimpleFilePreview;
